import {
  EStatusLinkManagement,
  EStatusLinkManagementValue,
} from '@organisms/Tables/Enterprise/LinksManagementTable/enums';
import { ELinkManagementTabs } from './enums';

export const LINK_MANAGEMENT_TABS: Record<
  ELinkManagementTabs,
  { title: string; disabled?: boolean }
> = {
  [ELinkManagementTabs.All]: { title: 'All' },
  [ELinkManagementTabs.ManuallySubmitted]: { title: 'Manually Submitted' },
  [ELinkManagementTabs.GoogleImages]: { title: 'Google Images', disabled: true },
  [ELinkManagementTabs.GoogleWeb]: { title: 'Google Web', disabled: true },
  [ELinkManagementTabs.AtSource]: { title: 'At Source' },
};

export const DEFAULT_TOAST_MESSAGE = {
  UPDATE: {
    SUCCESS: 'Update successfully',
    ERROR: 'Update error! Please check again.',
  },
  DELETE: {
    SUCCESS: 'Delete successfully',
    ERROR: 'Delete error! Please check again.',
  },
};

export const StatusLinkManagementValueMapper = {
  [EStatusLinkManagement.Detection]: EStatusLinkManagementValue.Detection,
  [EStatusLinkManagement.ClientReview]: EStatusLinkManagementValue.ClientReview,
  [EStatusLinkManagement.Enforcement]: EStatusLinkManagementValue.Enforcement,
  [EStatusLinkManagement.Resolved]: EStatusLinkManagementValue.Resolved,
  [EStatusLinkManagement.Archived]: EStatusLinkManagementValue.Archived,
  [EStatusLinkManagement.Pending]: EStatusLinkManagementValue.Pending,
};
